import Vue from 'vue'
import Vuex from 'vuex'
const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

// handle page reload
fb.auth.onAuthStateChanged(user => {
    if (user) {
        store.commit('setCurrentUser', user)
        store.dispatch('fetchUserProfile')

        fb.usersCollection.doc(user.uid).onSnapshot(doc => {
            store.commit('setUserProfile', doc.data())
        })

        // COMMENT ON POSTS
        {
        // realtime updates from our posts collection
        // fb.postsCollection.orderBy('createdOn', 'desc').onSnapshot(querySnapshot => {
        //     // check if created by currentUser
        //     let createdByCurrentUser
        //     if (querySnapshot.docs.length) {
        //         createdByCurrentUser = store.state.currentUser.uid == querySnapshot.docChanges()[0].doc.data().userId ? true : false
        //     }

        //     // add new posts to hiddenPosts array after initial load
        //     if (querySnapshot.docChanges().length !== querySnapshot.docs.length
        //         && querySnapshot.docChanges()[0].type == 'added' && !createdByCurrentUser) {

        //         let post = querySnapshot.docChanges()[0].doc.data()
        //         post.id = querySnapshot.docChanges()[0].doc.id

        //         store.commit('setHiddenPosts', post)
        //     } else {
        //         let postsArray = []

        //         querySnapshot.forEach(doc => {
        //             let post = doc.data()
        //             post.id = doc.id
        //             postsArray.push(post)
        //         })

        //         //store.commit('setPosts', postsArray)
        //     }
        // })
        }

        // Realtime updates from tiles
        fb.usersCollection.doc(user.uid).collection('tiles').orderBy('name', 'asc').onSnapshot(tilesSnapshot => {
            let tilesDict = {}

            // Populate tiles dict
            tilesSnapshot.forEach(tileDoc => {
                let tileData = tileDoc.data()
                let tile = {
                    services: {},
                    name: tileData.name,
                    ref: tileDoc.ref
                }
                tilesDict[tileDoc.id] = tile
            })
            store.commit('setTiles', tilesDict)
            
            // Attach listeners to all services of all tiles and populate services
            for (const [tileId, tile] of Object.entries(tilesDict)) {
                tile.ref.collection('services').onSnapshot(servicesSnapshot => {
                    let parentTileId = null
                    let servicesDict = {}
                    servicesSnapshot.forEach(serviceDoc => {
                        parentTileId = serviceDoc.ref.parent.parent.id
                        let serviceData = serviceDoc.data()
                        let service = {
                            name: serviceData.name,
                            unit: serviceData.unit,
                            latestData: '–',
                            ref: serviceDoc.ref,
                            active: (serviceData.active == true),
                            actionable: (serviceData.actionable == true)
                        }
                        servicesDict[serviceDoc.id] = service
                    })
                    let val = {
                        tileId: parentTileId,
                        servicesDict: servicesDict
                    }
                    store.commit('setServices', val)

                    // Attach listeners to data and update latest data
                    for (const [serviceId, service] of Object.entries(servicesDict)) {
                        service.ref.collection('data').orderBy('time', 'desc').limit(1).onSnapshot(servicesSnapshot => {
                            servicesSnapshot.forEach(dataDoc => {
                                let val = {
                                    tileId: dataDoc.ref.parent.parent.parent.parent.id,
                                    serviceId: dataDoc.ref.parent.parent.id,
                                    latestData: dataDoc.data()
                                }
                                store.commit('setLatestData', val)
                            })
                        })
                    }
                })
            }
        })

// OUT COMMENTED CODE FOR POSTS
{
//         // realtime updates from tiles
//         fb.usersCollection.doc(user.uid).collection('tiles').orderBy('name', 'asc').onSnapshot(function(tilesSnapshot) {
//             let tilesDict = []
//             let tilePromises = []

//             tilesSnapshot.forEach(tileDoc => {
//                 let tile = tileDoc.data()
//                 tile.id = tileDoc.id
//                 console.log("Tile", tile.name)

//                 let servicesArray = []
//                 let tilePromise = tileDoc.ref.collection('services').get().then(servicesSnapshot => {
//                     servicesSnapshot.forEach(serviceDoc => {
//                         let service = serviceDoc.data()
//                         service.id = serviceDoc.id
//                         console.log("Service", service.name)
//                         // Add latest value
//                         // serviceDoc.ref.collection('data').orderBy('time').limit(1).onSnapshot(dataSnapshot => {
//                         //     dataSnapshot.forEach(dataPoint => {
//                         //         service.latestData = dataPoint.data()
//                         //     })
//                         // })
//                         servicesArray.push(service)
//                     })
//                     return true
//                 }).then( function() {
//                     tile.services = servicesArray
//                     tilesDict.push(tile)
//                     console.log("tile pushed to array", tile.name)
//                     return true
//                 })
//                 tilePromises.push(tilePromise)
//             })
//             console.log("all tiles scheduled")
// //            return Promise.all(tilePromises)
//             console.log("pre-commit")
        
//             store.commit('setTiles', tilesDict)
//             console.log("tile array comitted to store")
//         })
}
    }
})

export const store = new Vuex.Store({
    state: {
        currentUser: null,
        userProfile: {},
        // posts: [],
        // hiddenPosts: [],
        tiles: {}
    },
    actions: {
        clearData({ commit }) {
            commit('setCurrentUser', null)
            commit('setUserProfile', {})
            // commit('setPosts', null)
            // commit('setHiddenPosts', null)
            commit('setTiles', null)
        },
        fetchUserProfile({ commit, state }) {
            fb.usersCollection.doc(state.currentUser.uid).get().then(res => {
                commit('setUserProfile', res.data())
            }).catch(err => {
                console.log(err)
            })
        },
        updateProfile({ commit, state }, data) {
            let name = data.name
            let title = data.title

            fb.usersCollection.doc(state.currentUser.uid).update({ name, title }).then(user => {
                // update all posts by user to reflect new name
                fb.postsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.postsCollection.doc(doc.id).update({
                            userName: name
                        })
                    })
                })
                // update all comments by user to reflect new name
                fb.commentsCollection.where('userId', '==', state.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fb.commentsCollection.doc(doc.id).update({
                            userName: name
                        })
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    },
    mutations: {
        setCurrentUser(state, val) {
            state.currentUser = val
        },
        setUserProfile(state, val) {
            state.userProfile = val
        },
        // setPosts(state, val) {
        //     if (val) {
        //         state.posts = val
        //     } else {
        //         state.posts = []
        //     }
        // },
        // setHiddenPosts(state, val) {
        //     if (val) {
        //         // make sure not to add duplicates
        //         if (!state.hiddenPosts.some(x => x.id === val.id)) {
        //             state.hiddenPosts.unshift(val)
        //         }
        //     } else {
        //         state.hiddenPosts = []
        //     }
        // },
        setTiles(state, val) {
            if (val) {
                state.tiles = val
            } else {
                state.tiles = {}
            }
        },
        setServices(state, val) {
            // TODO: check if tile exists
            let tile = state.tiles[val.tileId]  // Copy current tile
            // TODO: Check if dict is empty/null
            tile.services = val.servicesDict
            Vue.set(state.tiles, val.tileId, tile)
        },
        setLatestData(state, val) {
            // TODO: check if tile and service exists
            // TODO: Check if data is empty/null
            // if (val.latestData) {
            //     console.log('tileId', val.tileId)
            //     console.log('serviceId', val.serviceId)
            //     console.log('target object', state.tiles[val.tileId].services[val.serviceId])
            //     console.log('tmp')
            //     Vue.set(state.tiles[val.tileId].services[val.serviceId].latestData, 1, val.latestData)
            // } else {
            //     Vue.set(state.tiles[val.tileId].services[val.serviceId].latestData, 1, "")
            // }
            let service = state.tiles[val.tileId].services[val.serviceId]
            service.latestData = val.latestData
            Vue.set(state.tiles[val.tileId].services, val.serviceId, service)
        }
    }
})



// WEBPACK FOOTER //
// ./src/store.js